import React, { useEffect, useRef, useState } from "react";
import Images from "../../Component/Simage";

import tab1 from '../../Assets/ainfra/images/tab1.png'
import tab2 from '../../Assets/ainfra/images/tab2.png'
import tab3 from '../../Assets/ainfra/images/tab3.png'
import tab4 from '../../Assets/ainfra/images/tab4.png'
import tabRight from '../../Assets/ainfra/images/tabRight.png'
import tabCard from '../../Assets/ainfra/images/tabCard.jpg'

function AppDemo() {

  const containerRef = useRef(null);
  const [cardOneSlide, setCardOneSlide] = useState(false)
  const [cardTwoSlide, setCardTwoSlide] = useState(false)
  const [cardThreeSlide, setCardThreeSlide] = useState(false)
  const [cardFourSlide, setCardFourSlide] = useState(false)
  const [cardRightSlide, setCardRightSlide] = useState(false)

  // useEffect(() => {
  //   const handleEnter = () => {
  //     setTimeout(() => setCardOneSlide(true), 0);
  //     setTimeout(() => setCardTwoSlide(true), setCardRightSlide(true), 500);
  //     setTimeout(() => setCardThreeSlide(true), 1000);
  //     setTimeout(() => setCardFourSlide(true), 1500);
  //   };

  //   const handleExit = () => {
  //     setTimeout(() => setCardOneSlide(false), 0);
  //     setTimeout(() => setCardTwoSlide(false), setCardRightSlide(false), 500);
  //     setTimeout(() => setCardThreeSlide(false), 1000);
  //     setTimeout(() => setCardFourSlide(false), 1500);
  //   };

  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       const [entry] = entries;
  //       if (entry.isIntersecting) {
  //         handleEnter();
  //       } else {
  //         handleExit();
  //       }
  //     },
  //     { threshold: 0.5 }
  //   );

  //   if (containerRef.current) observer.observe(containerRef.current);

  //   return () => {
  //     if (containerRef.current) observer.unobserve(containerRef.current);
  //   };
  // }, []);


  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setTimeout(() => setCardOneSlide(true), 0);
          setTimeout(() => {
            setCardTwoSlide(true);
            setCardRightSlide(true);
          }, 500);
          setTimeout(() => setCardThreeSlide(true), 1000);
          setTimeout(() => setCardFourSlide(true), 1500);

          if (containerRef.current) {
            observer.unobserve(containerRef.current);
          }
        }
      },
      { threshold: 0.5 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <div className="app_demo">
      <p className="title fw-400 mb-3 mb-lg-4 mb-xxl-4 pb-xxl-3 text-center">
        Check the AInfra Node App Demo
      </p>
      <p className="des fw-300 text-center mb-3 mb-xxl-4">
        With 1 click installation you can set up an AInfra DePIN in minutes on
        any computer or laptop. <br /> DePIN operations run automatically in the
        background once the application is opened.
      </p>
      <p className="des fw-300 text-center mb-0">
        You can easily track important metrics such as your AInfra rewards and
        storage usage at any <br />
        time with just a few clicks.
      </p>
      {/* <div className="img_sec">
        <img src={Images.appDemo} className="img-fluid img_src" />
      </div> */}
      <div className="dp-tab__container" ref={containerRef}>
        <img
          src={tab1}
          className={`dp-tab__leftCard-one ${cardOneSlide ? "active" : ""}`}
        />
        <img
          src={tab2}
          className={`dp-tab__leftCard-two ${cardTwoSlide ? "active" : ""}`}
        />
        <img
          src={tab3}
          className={`dp-tab__leftCard-three ${cardThreeSlide ? "active" : ""}`}
        />
        <img
          src={tab4}
          className={`dp-tab__leftCard-four ${cardFourSlide ? "active" : ""}`}
        />
        <img
          src={tabRight}
          className={`dp-tab__leftCard-right ${cardRightSlide ? "active" : ""}`}
        />
      </div>
    </div>
  );
}

export default AppDemo;
